/*
 * @name: 路由缓存
 * @Author: zxc
 * @Date: 2021-04-08 18:27:11
 * @LastEditors: zxc
 * @LastEditTime: 2021-09-02 11:22:09
 */
const state = {
  beforeRoute: window.sessionStorage.getItem('beforeRoute'),
  beforeNewRoute: window.sessionStorage.getItem('beforeRoute')
}

const mutations = {
  SET_BEFOREROUTE: (state, beforeRoute) => {
    state.beforeRoute = beforeRoute
    window.sessionStorage.setItem('beforeRoute', beforeRoute)
    console.log('我是路由111', beforeRoute)
  },
  SET_BEFORE_NEW_ROUTE: (state, beforeNewRoute) => {
    state.beforeNewRoute = beforeNewRoute
    window.sessionStorage.setItem('beforeNewRoute', beforeNewRoute)
    console.log('我是路由222', beforeNewRoute)
  }
}

const actions = {
  getNeRoute({ commit, state }, val) { // 解决刷新页面时菜单栏高亮被替换成‘/’的问题
    return new Promise((resolve, reject) => {
      // console.log(from)
      // if (from.path !== '/' && !from.meta.guidePath) {
      //   console.log('before', from)
      //   commit('SET_BEFOREROUTE', from.path)
      //   resolve()
      // }
      commit('SET_BEFORE_NEW_ROUTE', val)
      resolve()
    })
  },
  getBeforeRoute({ commit, state }, val) {
    return new Promise((resolve, reject) => {
      console.log(val)
      const path = val.path
      if (!val.meta.guidePath) {
        console.log('before', path)
        commit('SET_BEFOREROUTE', path)
        resolve()
      }
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/router.js